import { isFunction } from 'lodash'
import { createStorage } from '../utils'

export default {
  computed: {
    localStore: {
      get() {
        const store = this.$get('localStore')
        if (isFunction(store)) return null
        return store
      },
      set(localStore) {
        this.$dispatch('setLocalStore', { localStore })
      }
    },
    localStoreContent() {
      if (this.localStore.hasOwnProperty('getStoreContent')) {
        return this.localStore.getStoreContent()
      }
      return {}
    },
    storageKey() {
      return this.$get('storageKey')
    },
  },
  methods: {
    createLocalStore(storageKey = this.storageKey) {
      this.localStore = createStorage(storageKey)
    },
    updateLocalStore({ prop, value }) {
      if (this.localStore) this.localStore.setItemValue(prop, value)
    },
  },
}